import { select_ui_settings } from '../redux/settings-actions';
import { ThemeType } from './types';
import branding from 'shared/app/model/branding';
export function selectThemeType(state) {
    const is_not_real_account = state.account.real_account &&
        state.account.real_account.id !== state.account.id;
    if (is_not_real_account && state.account.real_account?.is_support) {
        return ThemeType.LIGHT;
    }
    return branding.enable_dark_theme
        ? select_ui_settings(state).themeType ?? ThemeType.SYSTEM
        : ThemeType.LIGHT;
}
